import { createBlock } from './blockUtils';
import { htmlToText } from './caretUtils';

/**
 * Choice — a callout-like box whose children are `choice-path` blocks.
 * One path is visible at a time, or every path when `props.showAll`.
 */

export const createChoicePath = (label = 'Option A', firstChild = null) => {
  const path = createBlock('choice-path', label);
  path.children = [firstChild || createBlock('text')];
  return path;
};

export const createChoiceBlock = (beforeSlash = '') => {
  const first = createChoicePath('Option A');
  const second = createChoicePath('Option B');
  const choice = createBlock('choice', beforeSlash, {
    activePathId: first.id,
    showAll: false,
  });
  choice.children = [first, second];
  return choice;
};

export const choicePaths = (block) =>
  (block?.children || []).filter((child) => child.type === 'choice-path');

export const activeChoicePathId = (block) => {
  const paths = choicePaths(block);
  const wanted = block?.props?.activePathId;
  if (wanted && paths.some((path) => path.id === wanted)) return wanted;
  return paths[0]?.id || null;
};

export const isChoicePathVisible = (choice, pathId) => {
  if (!choice || choice.type !== 'choice') return true;
  if (choice.props?.showAll) return true;
  return activeChoicePathId(choice) === pathId;
};

/** Distinct fills for option tabs (cycles if a choice grows past the set). */
export const CHOICE_TAB_COLORS = [
  '#00d9ff',
  '#ffb020',
  '#c084fc',
  '#34d399',
  '#fb7185',
  '#60a5fa',
  '#fb923c',
  '#f472b6',
];

export const choiceTabColor = (index) =>
  CHOICE_TAB_COLORS[((Number(index) || 0) % CHOICE_TAB_COLORS.length + CHOICE_TAB_COLORS.length) % CHOICE_TAB_COLORS.length];

export const nextChoiceLabel = (paths) => {
  const used = new Set(
    (paths || []).map((path) => htmlToText(path.content || '').trim().toLowerCase())
  );
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  for (let i = 0; i < letters.length; i += 1) {
    const label = `Option ${letters[i]}`;
    if (!used.has(label.toLowerCase())) return label;
  }
  return `Option ${paths.length + 1}`;
};

